'use strict';

import angular from 'angular';


export default function($log, $http, $timeout, $scope) {
	'ngInject';

	var vm = this;
	vm.emergencyCall = false;
	var $incident = $scope.$incident;

	vm.deferred = $http.get('/api/entity/').then(function success(response) {
		vm.data = response.data;
		vm.data.roles.forEach(function(role) {
			// TODO: Remove this when we add support for marking users unavailable in
			// the admin interface.
			for(var i = 0; i < role.users.length; i++) {
				var user = role.users[i];
				// Remove inactive users, probably should filter this in the backend
				if (!user.is_active) {
					role.users.splice(i, 1);
					i--;
				}
			}
			role.target_count = 0;
			updateRoleRange(role);
		});
	}, function error(response) {
		$log.error(response);
	});

	var _userCache = {};

	vm.getUserByUUID = function(uuid) {
		if (user = _userCache[uuid]) return user;
		if (!vm.data) return;
		for(var i = 0, nbRoles = vm.data.roles.length; i < nbRoles; i++) {
			var role = vm.data.roles[i];
			for(var j = 0, nbUsers = role.users.length; j < nbUsers; j++) {
				var user = role.users[j];
				if (user.uuid == uuid) {
					_userCache[uuid] = user;
					return user;
				}
			}
		}
	}

	function updateRoleRange(role, delta) {
		if (!delta) delta = 0;
		var range = [0];
		for(var i = 1, nbUsers = role.users.length; i <= nbUsers+delta; i++) {
			range.push(i);
		}
		role.user_range = range;
	}

	vm.roleFilter = function(roleDisplayNameArray) {
		return function(role) {
			return roleDisplayNameArray.indexOf(role.display_name) > -1;
		};
	};

	vm.treeOptions = {
		accept: function(sourceNodeScope, destNodesScope, destIndex) {
			var source_role = sourceNodeScope.$parentNodesScope.$parent.$parent.role;
			var dest_role = destNodesScope.$parent.$parent.role;
			return source_role == dest_role;
		}
	};

	vm.processCallData = function() {
		vm.processedRoles = []
		vm.processedData = {};
		vm.data.roles.forEach(function(role) {
			if (role.target_count > 0) {
				var processedRoleData = {
					users: role.users.filter(u => u.is_available).map(u => u.uuid),
					target_count: role.target_count,
					call_time: vm.emergencyCall ? 5 : 300,
					min_call_count: vm.emergencyCall ? 3 : 1,
				}; 
				vm.processedData[role.display_name] = processedRoleData;
				vm.processedRoles.push(role);
				// if (!$incident.extra_data.hasOwnProperty('form_team_data')) {
				// 	$incident.extra_data.form_team_data = {};
				// }
				// $incident.extra_data.form_team_data[role.display_name] = processedRoleData;
			}
		});
	}

	vm.roleStates = {};

	function compareTimestamps(a, b) {
		var f = x => (new Date(x.time)).getTime();
		return f(a)-f(b);
	}

	function getRoleStates(log) {
		if (!log) return;
		var sortedLog = angular.copy(log).sort(compareTimestamps);
		// This is a pretty hacky way to get the state just from the log.  It
		// relies on parsing the log messages.
		for(var i = 0, logSize = log.length; i < logSize; i++) {
			var logEntry = sortedLog[i];
			var roleRegex = null, state;
			switch(logEntry.event) {
				case 'team:formation_initialized':
					roleRegex = /^Initiated calls to (.*)\s+group to form a team/;
					state = 'in-progress';
					break;
				case 'team:formation_failed':
					roleRegex = /Failed to form (.*)\s+team after/;
					state = 'failed';
					break;
				case 'team:formed':
					roleRegex = /Formation of (.*)\s+team is complete/;
					state = 'formed';
					break;
				case 'team:formation_paused':
					roleRegex = /Calls to (.*)\s+team have been paused/;
					state = 'paused';
					break;
				case 'team:formation_resumed':
					roleRegex = /Calls to (.*)\s+team have resumed/;
					state = 'in-progress';
					break;
			}
			if (roleRegex) {
				try {
					var roleName = roleRegex.exec(logEntry.message)[1];
					vm.roleStates[roleName] = state;
				} catch(e) {
					$log.error(e);
					$log.debug(logEntry);
				}
			}
		}
	}

	vm.restrictedRoleData = {};

	function processExtraData(data) {
		if (!data) return;
		Object.keys(data).forEach(function(roleName) {
			var restrictedData = {};
			restrictedData[roleName] = data[roleName];
			vm.restrictedRoleData[roleName] = restrictedData;
		});
	}

	$scope.$watch('$incident.log', getRoleStates, true);
	$scope.$watch('$incident.extra_data.form_team_data', processExtraData, true);
}
